import { motion } from 'framer-motion';
import { ShieldCheck, Zap, Globe, Users } from 'lucide-react';

const propositions = [
  { icon: ShieldCheck, title: "Fiabilité Garantie", desc: "Équipements certifiés et installations aux normes internationales pour une stabilité réseau maximale." },
  { icon: Zap, title: "Vitesse & Performance", desc: "Optimisation de vos flux de données pour booster la productivité de vos équipes au quotidien." },
  { icon: Globe, title: "Couverture Nationale", desc: "Nos techniciens interviennent partout au Sénégal : Dakar, Thiès, Saint-Louis, Casamance." },
  { icon: Users, title: "Support Dédié", desc: "Un interlocuteur unique et une assistance technique réactive 6 jours sur 7." },
];

const ValueProposition = () => {
  return (
    <section className="py-16 sm:py-24" style={{ borderTop: '1px solid var(--border)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {propositions.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.1 }}
              transition={{ delay: i * 0.1 }}
              style={{ willChange: 'transform, opacity' }}
              className="flex flex-col items-start"
            >
              <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-5" style={{ background: 'var(--bg-surface)', border: '1px solid var(--border)' }}>
                <item.icon size={22} style={{ color: 'var(--accent-green)' }} />
              </div>
              <h3 className="text-lg font-bold mb-3" style={{ color: 'var(--text-primary)' }}>{item.title}</h3>
              <p className="text-sm leading-relaxed" style={{ color: 'var(--text-secondary)' }}>{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValueProposition;
